import { ExtranetPendingChangeRequestType } from '~/services/ExtranetService';

type LabelInput = {
  request_type: ExtranetPendingChangeRequestType;
  target_ids?: Record<string, string> | null;
};

const ROOMS_REQUEST_TYPES = new Set<ExtranetPendingChangeRequestType>([
  'room_type',
  'room_availability',
  'rate_plan',
  'promotional_discount',
]);

const REQUEST_TYPE_FALLBACK_LABELS: Record<ExtranetPendingChangeRequestType, string> = {
  property: 'Property Details',
  property_meta: 'Property Details',
  property_taxes: 'Taxes',
  property_facility: 'Facilities',
  property_image: 'Images',
  room_type: 'Rooms',
  room_availability: 'Rooms',
  rate_plan: 'Rooms',
  promotional_discount: 'Rooms',
};

const SECTION_TAB_LABELS: Record<string, string> = {
  description: 'Description',
  check_in_arrival: 'Policies',
  fine_print: 'Policies',
  contact: 'Property Details',
  core: 'Property Details',
  occupancy: 'Property Details',
  taxes_content: 'Taxes',
};

const SECTION_DETAIL_LABELS: Record<string, string> = {
  description: 'Description',
  check_in_arrival: 'Check-in & arrival',
  fine_print: 'Fine print',
  contact: 'Contact',
  core: 'Core details',
  occupancy: 'Occupancy',
  taxes_content: 'Tax content',
};

export const REQUEST_TYPE_DETAIL_LABELS: Record<ExtranetPendingChangeRequestType, string> = {
  property: 'Property sections',
  property_meta: 'Meta sections',
  property_taxes: 'Tax line items',
  property_facility: 'Facilities',
  property_image: 'Images',
  room_type: 'Room type',
  room_availability: 'Room availability',
  rate_plan: 'Rate plan',
  promotional_discount: 'Promotional discount',
};

export function getExtranetApprovalLabel(change: LabelInput): string {
  if (ROOMS_REQUEST_TYPES.has(change.request_type)) return 'Rooms';

  const section = change.target_ids?.section;
  if (section && SECTION_TAB_LABELS[section]) return SECTION_TAB_LABELS[section];

  return REQUEST_TYPE_FALLBACK_LABELS[change.request_type] ?? change.request_type;
}

export function getExtranetApprovalSectionLabel(targetIds?: Record<string, string> | null): string | undefined {
  const section = targetIds?.section;
  if (!section) return undefined;
  return SECTION_DETAIL_LABELS[section] ?? section;
}

export function getExtranetApprovalFilterOptions(): Array<{ value: ExtranetPendingChangeRequestType; label: string }> {
  return [
    { value: 'room_type', label: 'Room details' },
    { value: 'room_availability', label: 'Room availability' },
    { value: 'rate_plan', label: 'Rate plans' },
    { value: 'promotional_discount', label: 'Promotions' },
    { value: 'property_meta', label: 'Description, policies, contact' },
    { value: 'property', label: 'Property details and tax content' },
    { value: 'property_taxes', label: 'Tax line items' },
    { value: 'property_facility', label: 'Facilities' },
    { value: 'property_image', label: 'Images' },
  ];
}
